'use client';

import { c as _c } from "react/compiler-runtime";
import { type IntlError, IntlErrorCode, NextIntlClientProvider, useLocale } from 'next-intl';
import type { ReactNode } from "react";
export default function IntlErrorHandlingProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const locale = useLocale();
  const handleNextIntlError = _temp;
  let t1;
  if ($[0] !== children || $[1] !== locale) {
    t1 = <NextIntlClientProvider locale={locale} onError={handleNextIntlError}>{children}</NextIntlClientProvider>;
    $[0] = children;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(error) {
  if (error.code !== IntlErrorCode.MISSING_MESSAGE) {
    console.error("====> Translation error:", error.message);
  }
}